<template>
  <div class="mydhkReceiveResumeIndex">

    <div
      class="cont"
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0)"
    >
      <div class="selectCont">
        <span
          style="color: #5DC1CF"
          @click="getkf"
        >我的账户{{ cash ? cash.availableAmount + ' 元 丨 ' : ' 0 元 丨 ' }}</span>
        <span style="color: #5DC1CF">请选择职位类型：</span>
        <el-cascader
          placeholder="请选择职位类型"
          :options="jobTypeOptions"
          :show-all-levels="false"
          @change="changejobType"
          clearable
          filterable
        ></el-cascader>
      </div>
      <div class="tableCont">
        <el-table
          :data="resumeList"
          border
          style="width: 100%"
          :row-key=" (e)=>{return e.id}"
        >
          <el-table-column prop="name" label="简历名称" align="center"></el-table-column>
          <el-table-column prop="city" label="所在城市" align="center"></el-table-column>
          <el-table-column prop="createTime" label="投递时间" align="center"></el-table-column>
          <el-table-column align="center" label="工作年限">
            <template slot-scope="scope">
              <span v-if="scope.row.workingLifeMin > 10 && scope.row.workingLifeMax > 10">10年以上</span>
              <span
                v-if="scope.row.workingLifeMin < 11 && scope.row.workingLifeMax > 10"
              >{{ scope.row.workingLifeMin }}年以上</span>
              <span
                v-if="((scope.row.workingLifeMin !== scope.row.workingLifeMax) && scope.row.workingLifeMin < 11 && scope.row.workingLifeMax < 11)"
              >{{ scope.row.workingLifeMin }}~{{ scope.row.workingLifeMax }}年</span>
              <span
                v-if="((scope.row.workingLifeMin === scope.row.workingLifeMax) && scope.row.workingLifeMin < 11)"
              >{{ scope.row.workingLifeMin }}年</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="年薪">
            <template
              slot-scope="scope"
            >{{ scope.row.minYearSalary === scope.row.maxYearSalary ? scope.row.minYearSalary + 'w' : scope.row.minYearSalary + '~' + scope.row.maxYearSalary + 'w' }}</template>
          </el-table-column>
          <el-table-column align="center" label="操作">
            <template slot-scope="scope">
              <el-button @click="openPdf(scope.row.oldFileUrl)" type="text" size="small">查看简历</el-button>
              <el-button v-if="cash !== null" @click="goMakePhone(scope.row)" type="text" size="small">获取电话</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="paginationBox">
      <el-pagination
        :page-size.sync="resumePageSize"
        :pager-count="11"
        layout="prev, pager, next"
        :total="resumePageTotle"
        @current-change="handleCurrentChange"
      ></el-pagination>
    </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Config from "../config/index";
export default {
  name: "dhk",
  props: {},
  data() {
    return {
      cash: null,
      jobTypeOptions: [],
      jobTypeCode: "",
      jobType: "",
      jobName: "全部职位",
      jobPageNum: 1,
      jobPageSize: 200,
      jobList: [],
      dataList: [],
      resumeStatus: "1",
      resumeList: [],
      resumePageNum: 1,
      resumePageSize: 11,
      resumePageTotle: 0,
      loading: false,
      setItem: null,
      setIndex: "",
    };
  },
  watch: {},
  created: function () { },
  methods: {
    getJobTypeArray: function () {
      let that = this;
      axios({
        method: "GET",
        url: Config.path + "/api/common/treedata/gettreeData",
      })
        .then((res) => {
          if (res.data.success === "1") {
            that.gsArray(res.data.content);
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch((err) => {
           
          that.$message.error("无法连接网络,请检查WiFi或移动数据网络是否正常");
        });
    },
    gsArray: function (list) {
      for (let i in list) {
        let item = list[i];
        item.label = item.name;
        item.value = item.name + "," + item.code;
        if (item.childrenlist) {
          item.children = item.childrenlist;
          for (let j in item.children) {
            let item2 = item.children[j];
            item2.label = item2.name;
            item2.value = item2.name + "," + item2.code;
            if (item2.childrenlist) {
              item2.children = item2.childrenlist;
              for (let k in item2.children) {
                let item3 = item2.children[k];
                item3.label = item3.name;
                item3.value = item3.name + "," + item3.code;
              }
            }
          }
        }
      }
      this.jobTypeOptions = list;
    },
    changejobType: function (e) {
      this.jobTypeCode = e[e.length - 1].split(",")[1];
      this.jobType = e[e.length - 1].split(",")[0];
      this.pageNum = 1;
      this.getDhkList();
    },
    getkf: function () {
      let that = this;
      this.$alert(
        `<div>
                <div style="color: red;paddingBottom: 20px">您的汇款识别码为：{${that.$store.state.userStatus.companyVo.payIdentificationCode}}(请在汇款时备注)</div>
                <div >户名： 北京乐路互动咨询有限公司</div>
                <div>账户： 1105 0163 9800 0000 0102</div>
                <div>开户行： 中国建设银行北京小营东路支行</div>
                 <div style="color: red;paddingBottom: 20px">请在[聘快快企业版]小程序联系客服</div>
              </div>`,
        "提示",
        {
          dangerouslyUseHTMLString: true,
        }
      );
    },
    getDhkList: function () {
      let that = this;
      that.loading = true;
      let data = {
        pageNum: that.resumePageNum,
        pageSize: that.resumePageSize,
      };
      if (that.jobTypeCode !== "") {
        data.jobTypeCode = that.jobTypeCode;
      }
      axios({
        method: "POST",
        url: Config.path + "/api/enterprise/resume/getPublicResume",
        headers: {
          token: localStorage.getItem("token"),
          "content-type": "application/json",
        },
        data: data,
      })
        .then((res) => {
          that.loading = false;
          if (res.data.success === "1") {
            let demoList = [];
            demoList = res.data.content.list;
            for (let item in demoList) {
              var a = moment();
              var b = moment(demoList[item].createTime);
              if (a.diff(b, "days") >= 1) {
                if (
                  moment(demoList[item].createTime).format("YYYY") ===
                  moment().format("YYYY")
                ) {
                  demoList[item].xsTime =
                    moment(demoList[item].createTime).format("MM月DD日") + " ";
                } else {
                  demoList[item].xsTime =
                    moment(demoList[item].createTime).format("YYYY年MM月DD日") +
                    " ";
                }
              } else if (a.diff(b, "hours") >= 1) {
                demoList[item].xsTime = a.diff(b, "hours") + "小时前 ";
              } else if (a.diff(b, "minutes") >= 1) {
                demoList[item].xsTime = a.diff(b, "minutes") + "分钟前 ";
              } else {
                demoList[item].xsTime = "刚刚 ";
              }
              // let zjNx =
              //   ((Number(demoList[item].maxYearSalary) +
              //     Number(demoList[item].minYearSalary)));
              //  
              // for (let m in jlList) {
              //   if (
              //     zjNx <= Number(jlList[m].maxYearSalary) &&
              //     zjNx > Number(jlList[m].minYearSalary)
              //   ) {
              //     console.log(jlList[m]);
              //     demoList[item].jlItem = jlList[m];
              //   }
              // }
            }
             
            that.dataList = demoList;
            that.resumeList = demoList;
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch((err) => {
           
          that.loading = false;
          that.$message.error("无法连接网络,请检查WiFi或移动数据网络是否正常");
        });
    },
    selectJob: function (e) {
      this.jobName = e;
      this.resumePageNum = 1;
      this.getDhkList();
    },
    changeResumeStatus: function (e) {
      this.resumeStatus = e;
      this.resumePageNum = 1;
      this.getDhkList();
    },
    handleCurrentChange: function (e) {
      this.resumePageNum = e;
      this.getDhkList();
    },
    openPdf: function (url) {
      window.open(url, "_blank");
    },

    goMakePhone: function (item, index) {
       
      let cash = this.cash
       
      if (item.isPurchase) {
        this.$alert(`手机号码为：${item.phone}`, "提示", {
          confirmButtonText: "确定",
          callback: (action) => {
          },
        });
      } else {
        if (Number(cash.availableAmount) <= 0) {
          this.$alert(`当前余额不足`, "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
            },
          });
        } else {
          this.setItem = item;
          this.setIndex = index;
          this.$alert(`本次消费100元,确定消费吗`, "提示", {
            confirmButtonText: "确定",
            callback: (action) => {
              that.buyPhone();
            },
          });
        }
      }
    },

    buyPhone: function () {
      let that = this;
      const { setIndex, setItem } = this;
      let { dataList } = this;
      axios({
        method: "post",
        url: Config.path + "/api/enterprise/company/telPurchase",
        header: { token: localStorage.getItem("token") },
        data: {
          resumeId: setItem.resumeId,
        },
        success: function (res) {
          if (res.data.success === "1") {
            let demo = dataList;
            demo[setIndex].isPurchase = "asdas";
            that.dataList = demo;
            that.getCashInfo();
            this.$alert(`手机号码为：${setItem.phone}`, "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
              },
            });
          } else {
            that.$message.error(res.data.message);
          }
        },
        fail: function () {
        },
      });
    },
    popover: function (index, flag, status) {
      let list = this.resumeList;
      list[index]["visible" + flag] = false;
      if (status) {
        this.flagResume(index, flag);
      }
    },
    flagResume: function (index, flag) {
      let that = this;
      axios({
        method: "POST",
        url: Config.path + "/api/enterprise/resume/flagStatus",
        headers: {
          token: localStorage.getItem("token"),
          "content-type": "application/json",
        },
        data: {
          candidateId: this.resumeList[index].id,
          resumeEnterpriseStatus: flag,
        },
      })
        .then((res) => {
          if (res.data.success === "1") {
            that.resumeList[index].entryPersonStatus = flag;
          } else {
            that.$message.error(res.data.message);
          }
        })
        .catch((err) => {
           
          that.$message.error("无法连接网络,请检查WiFi或移动数据网络是否正常");
        });
    },
    getCashInfo: function () {
       
      // let that = this;
      // axios({
      //   method: "post",
      //   url: Config.path + "/api/enterprise/company/getCompanyAmount",
      //   headers: {
      //     token: localStorage.getItem("token")
      //   },
      // }).then((res) => {
         
      //     if (res.data.success === "1") {
      //       that.cash = res.data.content;
      //     } else {
             
      //       that.$message.error(res.data.message);
      //     }
      //   })
      //   .catch((err) => {
           
      //     that.$message.error("无法连接网络,请检查WiFi或移动数据网络是否正常");
      //   });
    },
  },
  mounted: function () {
    this.getJobTypeArray();
    this.getDhkList();
    this.getCashInfo();
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style lang="scss">
.mydhkReceiveResumeIndex {
  min-width: 100vw;
    flex: 1;
    padding-top: 1px;
    position: relative;
    background-color: #e6e6e6;
  .paginationBox {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    position: fixed;
            bottom: 100px;
    left: 50%;
    transform: translateX(-50%);
    background-color: #ffffff;
    width: max-content;
    padding: 5px 40px;
    z-index: 9999;
    border-radius: 10px;

    .el-pager {
      li {
        background: transparent;
        color: #5dc2d0;
      }

      .active {
        background: #fff;
        color: #5dc2d0;
      }
    }

    .el-pagination .btn-prev,
    .el-pagination .btn-next {
      background-color: transparent;

      i {
        color: #ffffff;
      }
    }
  }
  .cont {
    width: 100vw;
    overflow-x: scroll;
        height: calc(100%);
        border-radius: 8px;
        box-sizing: border-box;
    // overflow: hidden;
    display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-start;


    .selectCont {
            width: 311px;
            background-color: #ffffff;
            box-sizing: border-box;
            margin-top: 30px;
            padding: 35px 22px;
            border-radius: 10px;
            margin-left: 20px;
      .el-select {
        .el-input {
          color: #5dc2d0;

          .el-input__inner {
            background-color: transparent;
            border: none;
            color: #5dc2d0;

            &::-webkit-input-placeholder {
              color: #5dc2d0;
            }
          }

          .el-select__caret {
            color: #5dc2d0;
          }
        }
      }

      .el-radio-group {
        margin-left: 40px;

        .el-radio-button__inner {
          background-color: transparent;
          color: #5dc2d0;
        }

        .is-active {
          .el-radio-button__inner {
            background-color: #5dc2d0;
            color: #fff;
            border-color: #5dc2d0;
          }
        }
      }
    }

    .tableCont {
            flex: 0.9;
            margin-top: 30px;
            box-sizing: border-box;
            background-color: #ffffff;
            margin-right: 20px;
            border-radius: 10px;
            padding: 30px;
            position: relative;
            overflow-x: scroll;

      * {
        background-color: transparent;
        color: #5dc2d0;
      }

      .el-table--group,
      .el-table--border {
        border: none;

        &:after {
          border: none;
        }
      }

      .el-table--group,
      .el-table--border {
        border: none;
      }

      .el-table--border th,
      .el-table--border td {
        border: none;
      }

      .el-table--group::after,
      .el-table--border::after,
      .el-table::before {
        height: 0;
        width: 0;
      }

      .el-table__header-wrapper {
        border-bottom: 1px solid #5dc2d0;
      }

      .el-table__body tr {
        > td {
          span {
            margin: 0 5px;
          }
        }

        &:hover {
          > td {
            background-color: #5dc2d0;

            div {
              color: #ffffff;
            }

            span {
              color: #ffffff;
              margin: 0 5px;
            }
          }
        }
      }
    }
  }
}
</style>
